var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheckmarkCircle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 414.93 414.93",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 207.46,
    cy: 207.46,
    r: 202.46,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164,315l-88.1-88.1a13.56,13.56,0,0,1,0-19.17L95.07,188.6a13.53,13.53,0,0,1,19.16,0l59.35,59.34L300.7,120.83a13.55,13.55,0,0,1,19.16,0L339,140a13.55,13.55,0,0,1,0,19.16L183.16,315A13.55,13.55,0,0,1,164,315Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckmarkCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkmark-circle.65f502b7.svg";
export { ForwardRef as ReactComponent };